import { SnackbarProvider } from "notistack";
import SnackbarSuccess from "./Snackbar/Success";
import SnackbarWarning from "./Snackbar/Warning";
import SnackbarError from "./Snackbar/Error";

export const SnackbarWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={3000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      Components={{
        success: SnackbarSuccess,
        warning: SnackbarWarning,
        error: SnackbarError,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};
